import { all, takeEvery, put, fork, call } from 'redux-saga/effects';
import actions from './actions';

export function* getPromotions() {
    yield takeEvery(actions.FETCH_PROMOTIONS_REQUESTED, function* (action) {
        try {
          const promotions = yield call(actions.getPromotions, action.payload);
          yield put({ type: actions.FETCH_PROMOTIONS_SUCCEEDED, promotions });
        } catch (error) {
          yield put({ type: actions.FETCH_PROMOTIONS_FAILED, error: error.message });
        }
    });
}

export function* getPromotion() {
    yield takeEvery(actions.FETCH_PROMOTION_REQUESTED, function* (action) {
        try {
            const promotion = yield call(actions.getPromotion, action.payload);
            yield put({ type: actions.FETCH_PROMOTION_SUCCEEDED, promotion: promotion.offer_info });
        } catch (error) {
            yield put({ type: actions.FETCH_PROMOTION_FAILED, error: error.message });
        }
    });
}

export function* deletePromotion() {
  yield takeEvery(actions.DELETE_PROMOTION_REQUESTED, function* (action) {
      try {
          const promotion = yield call(actions.deletePromotion, action.payload);
          yield put({ type: actions.DELETE_PROMOTION_SUCCEEDED, promotionDeleted: promotion });
      } catch (error) {
          yield put({ type: actions.DELETE_PROMOTION_FAILED, error: error.message });
      }
  });
}

export default function* rootSaga() {
  yield all([
    fork(getPromotions),
    fork(getPromotion),
    fork(deletePromotion)
  ]);
}
